"use client";

import { useState } from "react";
import axiosInstance from "@libs/axios";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { apiUrl } from "@constants/url";

/**
 * Restores a soft-deleted doc pabean entry back into the list and refreshes
 * the doc-pabeans query. The CEISA filing was never removed by the delete, so
 * this only makes the row visible in Jarvis again.
 */
export default function useRestoreDocPabean() {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const restoreDocPabean = async (id: number): Promise<boolean> => {
    setLoading(true);
    try {
      await axiosInstance.patch(apiUrl.docPabean.restore(id));
      notifications.show({
        title: "Dipulihkan",
        message: "Dokumen dikembalikan ke daftar",
        color: "green",
      });
      await queryClient.invalidateQueries({ queryKey: ["doc-pabeans"] });
      return true;
    } catch (error: any) {
      notifications.show({
        title: "Error",
        message:
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          "Gagal memulihkan dokumen",
        color: "red",
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { restoreDocPabean, loading };
}
